<template>
  <el-container class="list">
    <el-button
      v-if="hasToken && !isFromCCRCWindow"
      class="logout"
      size="mini"
      @click="logout"
      type="danger"
      >退出登录</el-button>
    <el-aside width="180px">
      <ul class="menu">
        <li
          :index="item.categoryValue"
          :key="item.categoryValue"
          v-for="item in typeList"
          :class="{ 'is-active': item.categoryValue === activeName }"
          @click="handleSelect(item.categoryValue)"
        >
          <i class="el-icon-s-order"></i>
          {{ item.categoryKey }}
        </li>
      </ul>
    </el-aside>
    <el-container>
      <el-header class="content__header">
        <div class="content__box content__nav">
          <div class="content__add" @click="handleAdd">
            <img
              :src="`${appUrl}img/new-project.png`"
              height="40px"
              alt=""
            />
            <p>新建大屏</p>
          </div>
          <div class="content__page">
            <el-pagination
              v-if="page.total > 0"
              layout="total, sizes, prev, pager, next, jumper"
              background
              size="small"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-size="page.size"
              :current-page.sync="page.page"
              :total="page.total"
            >
            </el-pagination>
          </div>
        </div>
      </el-header>
      <el-main class="content" v-loading="loading" v-bind="$loadingParams">
        <div class="content__box">
          <div
            class="content__item"
            v-for="(item, index) in list"
            :key="index"
            @mouseover="item._menu = true"
            @mouseout="item._menu = false"
          >
            <div class="content__info">
              <img v-if="item.backgroundUrl" :src="item.backgroundUrl" alt="" />
              <div class="content__menu" v-show="item._menu">
                <div class="content__right">
                  <el-tooltip content="导出">
                    <i
                      class="el-icon-download"
                      @click="handleExport(item, index)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip content="预览">
                    <i
                      class="el-icon-view"
                      @click="handleViews(item, index)"
                    ></i>
                  </el-tooltip>
                </div>
                <div class="content__btn" @click="handleEdit(item)">编辑</div>
                <div class="content__list">
                  <el-tooltip content="修改">
                    <i
                      class="el-icon-edit"
                      @click="handleUpdate(item, index)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip content="删除">
                    <i
                      class="el-icon-delete"
                      @click="handleDel(item, index)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip content="复制">
                    <i
                      class="el-icon-copy-document"
                      @click="handleCopy(item, index)"
                    ></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div class="content__main">
              <span class="content__name">{{ item.title }}</span>
              <div class="content__menulist">
                <span
                  class="content__status"
                  :class="{ 'is-active': item.status }"
                >
                  <span class="icon"></span>
                  {{ item.status == 1 ? "已发布" : "未发布" }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
    <el-dialog
      title="编辑大屏"
      width="50%"
      :close-on-click-modal="false"
      :visible.sync="box"
    >
      <avue-form :option="option" v-model="form" @submit="handleSave">
        <template slot="backgroundUrl">
          <img :src="form.backgroundUrl" style="width: 200px" alt="" />
          <el-upload
            :on-success="onSuccess"
            :on-progress="onProgress"
            :show-file-list="false"
            :action="url + '/visual/put-file'"
            multiple
            list-type="picture"
          >
            <el-button
              size="small"
              :loading="loading1"
              icon="el-icon-upload"
              type="primary"
              >点击上传</el-button
            >
          </el-upload>
        </template>
      </avue-form>
    </el-dialog>
    <export-tip ref="exportTip"></export-tip>
  </el-container>
</template>
<script>
import { getList, updateObj, delObj, getCategory, copyObj } from "@/api/visual";
import { url } from "@/config";
import exportTip from "@/page/components/export-tip";
import store2 from "store2";

export default {
  name: "list",
  components: {
    exportTip,
  },
  data() {
    return {
      appUrl:process.env.VUE_APP_URL,
      isFromCCRCWindow:window.isFromCCRCWindow ? true :false,
      loading1: false,
      loading: false,
      typeList: [],
      box: false,
      url,
      option: {
        submitText: "修改大屏",
        column: [
          {
            label: "分组",
            prop: "category",
            span: 24,
            labelWidth: 100,
            type: "select",
            dicUrl: url + "/category/list",
            props: {
              label: "categoryKey",
              value: "categoryValue",
            },
            rules: [
              {
                required: true,
                message: "请选择分组",
                trigger: "blur",
              },
            ],
          },
          {
            label: "大屏名称",
            span: 24,
            labelWidth: 100,
            prop: "title",
            rules: [
              {
                required: true,
                message: "请输入大屏名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "密码",
            span: 24,
            type: "password",
            labelWidth: 100,
            prop: "password",
          },
          {
            label: "发布状态",
            prop: "status",
            span: 24,
            labelWidth: 100,
            type: "select",
            dicData: [
              {
                label: "未发布",
                value: 0,
              },
              {
                label: "已发布",
                value: 1,
              },
            ],
          },
          {
            label: "缩略图",
            span: 24,
            labelWidth: 100,
            prop: "backgroundUrl",
          },
        ],
      },
      page: {
        page: 1,
        size: 50,
        total: 0,
      },
      form: {},
      activeName: "",
      list: [],
    };
  },
  created() {
    this.getCategory();
  },
  computed: {
    hasToken() {
      return store2.has("token");
    },
  },
  methods: {
    onProgress() {
      this.loading1 = true;
    },
    onSuccess(res) {
      const url = res.data.link;
      this.loading1 = false;
      this.form.backgroundUrl = url;
    },
    handleSelect(key) {
      this.activeName = key;
      this.page.page = 1;
      this.getList();
    },
    vaildData(id) {
      const list = [];
      for (var i = 0; i < 20; i++) {
        list.push(i);
      }
      return list.includes(id);
    },
    getCategory() {
      getCategory().then((res) => {
        const data = res.data.data;
        this.typeList = data;
        this.activeName = (data[0] || {}).categoryValue;
        this.getList();
      });
    },
    handleExport(item) {
      this.$refs.exportTip.handleOpen(item);
    },
    handleCopy(item) {
      if (this.$website.isDemo) {
        this.$message.error(this.$website.isDemoTip);
        return;
      }
      this.$confirm("确认复制当前大屏", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          copyObj(item.id).then((res) => {
            this.$message.success("复制成功");
            const id = res.data.data;
            this.handleEdit({ id });
          });
        })
        .catch(() => {});
    },
    handleDel(item, index) {
      if (this.vaildData(index) && this.$website.isDemo) {
        this.$message.error(this.$website.isDemoTip);
        return false;
      }
      this.$confirm("是否确认永久删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delObj(item.id).then(() => {
            this.list.splice(index, 1);
            this.$message.success("删除成功");
          });
        })
        .catch(() => {});
    },
    handleAdd() {
      this.$router.push({
        path: "/create",
        query: {
          category: this.activeName,
        },
      });
    },
    handleUpdate(item, index) {
      if (this.vaildData(Number(index)) && this.$website.isDemo) {
        this.$message.error(this.$website.isDemoTip);
        return false;
      }
      this.form = item;
      this.form.category = this.form.category + "";
      this.box = true;
    },
    handleEdit(item) {
      let routeUrl = this.$router.resolve({
        path: "/build/" + item.id,
      });
      window.open(routeUrl.href, "_blank");
    },
    handleViews(item) {
      let routeUrl = this.$router.resolve({
        path: "/view/" + item.id,
      });
      window.open(routeUrl.href, "_blank");
    },
    handleSave(form, done) {
      updateObj({
        id: this.form.id,
        category: this.form.category,
        password: this.form.password,
        status: this.form.status,
        title: this.form.title,
        backgroundUrl: this.form.backgroundUrl,
      }).then(() => {
        done();
        this.box = false;
        this.$message.success("修改成功");
        this.getList();
      });
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getList();
    },
    getList(category) {
      this.loading = true;
      this.list = [];
      getList({
        category: category || this.activeName,
        current: this.page.page,
        size: this.page.size,
      }).then((res) => {
        this.loading = false;
        const data = res.data.data;
        this.page.total = data.total;
        this.list = data.records;
        this.list.forEach((ele, index) => {
          this.$set(this.list[index], "_menu", false);
        });
      });
    },
    logout() {
      store2.remove("token");
      this.$router.replace("/login");
    },
    backHome(){
      setTimeout(function() {
        if(process.env.NODE_ENV === "development"){
          window.location.assign("http://localhost:5000/systemview");
        }else{
          window.location.assign("https://test.lcchunyi.com/systemview");
        }
        
      }, 100); 
    },
  },
};
</script>
<style scoped>
.logout {
  position: absolute;
  bottom: 16px;
  left: 16px;
}
</style>
